import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../App.context';
import { ApiContext } from '../../../utils/networking/Api.context';
import { notification } from 'antd';

export default function useDefaultInfoTextsHook() {
  const { API } = useContext(ApiContext);
  const {
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);

  // Definimos tipos de texto para guardar y filtrar
  const TEXT_TYPES = ['start-checkin', 'end-checkin', 'sign-info'];

  const [state, setState] = useState({
    texts: [],

    // Estos tres textos serán los que se editan y muestran
    startCheckinText: '',
    endCheckinText: '',
    legalDocumentsText: '',

    selectedLanguage: 'es',
    isLoading: false,
  });

  useEffect(() => {
    if (!getSelectedHotel()?.key) return;
    actions.getHotelTexts();
  }, [getSelectedHotel()?.key]);

  // Actualizar textos cuando cambie idioma o lista de textos
  useEffect(() => {
    actions.getSelectedText(state.texts);
  }, [state.selectedLanguage]);

  // Actualizar parte del estado
  function updateState(object) {
    setState(prev => ({ ...prev, ...object }));
  }

  const actions = {
    setSelectedLanguage: languageObj => {
      updateState({ selectedLanguage: languageObj.code });
      actions.getSelectedText(state.texts, languageObj.code);
    },

    getHotelTexts: async () => {
      try {
        updateState({ isLoading: true });
        const hotelId = getSelectedHotel().key;
        const response = await API.getHotelTexts(hotelId, TEXT_TYPES);
        const texts = response?.hotelTexts || [];
        updateState({ texts, isLoading: false });

        actions.getSelectedText(texts);
      } catch (error) {
        console.error('Error loading hotel texts', error);
        updateState({ isLoading: false });
      }
    },

    getSelectedText: (texts = state.texts, lang = state.selectedLanguage) => {
      if (!texts.length) return;

      const getTextByType = type => {
        const match = texts.find(t => t.type === type && t.lang === lang);
        return match?.value || '';
      };

      updateState({
        startCheckinText: getTextByType('start-checkin'),
        endCheckinText: getTextByType('end-checkin'),
        legalDocumentsText: getTextByType('sign-info'),
      });
    },

    handleEditorChange: (newValue, fieldName) => {
      updateState({ [fieldName]: newValue });
    },

    saveHotelText: async (hotelId, type, value, lang) => {
      try {
        await API.updateLegalTextRequest({
          hotelId,
          type,
          value,
          lang,
        });
        notification.success({
          message: translate('informationTexts.updateSuccess'),
        });
      } catch (error) {
        notification.success({
          message: translate('informationTexts.updateError'),
        });
      }
    },

    onSavePressed: async (type, value, applyToAllHotels) => {
      try {
        const hotelId = applyToAllHotels ? null : getSelectedHotel().key;

        const lang = state.selectedLanguage;

        await actions.saveHotelText(hotelId, type, value, lang);

        // Refrescar datos tras guardar
        await actions.getHotelTexts();
      } catch (error) {}
    },
  };

  return { state, actions };
}
